import { resolveRenderer } from './evidenceRenderers';
import type { AlertDetailResponse } from '@/types/alerts';

interface WhyFiredSectionProps {
  alert: AlertDetailResponse;
}

/**
 * Section 3: rule description + structured evidence payload.
 *
 * In PR 2 every rule_id falls through to the default key/value table
 * renderer. Per-rule custom renderers (chart cards, transaction blow-ups,
 * mini maps) land in PR 3 under
 * `evidenceRenderers/custom/<rule_id>.tsx`.
 */
export function WhyFiredSection({ alert }: WhyFiredSectionProps): JSX.Element {
  const render = resolveRenderer(alert.rule_id);
  return (
    <section aria-labelledby="why-fired">
      <h2 id="why-fired" className="text-lg font-semibold">
        Why this rule fired
      </h2>
      <p className="mt-1 whitespace-pre-wrap text-sm text-muted-foreground">
        {alert.description}
      </p>
      {alert.summary && (
        <p className="mt-2 whitespace-pre-wrap text-sm">{alert.summary}</p>
      )}
      <div className="mt-4">
        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          Evidence payload
        </h3>
        {render(alert.evidence, alert)}
      </div>
    </section>
  );
}
